import { IApplianceModel } from '../Appliance/ApplianceModel';
import { IBaseModel } from '../system/BaseModel';

export interface IActionProfile extends IBaseModel {
  hardwareTypeId: string;
  hardwareManufacturerId: string;
  hardwareModelId: string;
  hardwareModel: IApplianceModel;
  commands: object[];
  responseLength: number;
  responseTimeout: number;
  actionId: string;
  dataPointId: string;
  inputType: InputType;
  step: number;
  restore?: boolean;
}

export enum InputType {
  None,
  Toggle,
  Select,
  Value,
  Update,
}
